import { createSlice } from '@reduxjs/toolkit';

import { submitSearch } from '../search.actions';
import { fetchRelatedSearchesForSearchPage } from './relatedSearches.actions';
import { RelatedSearchItem } from './relatedSearches.types';

export type RelatedSearchesSlice = {
    /** Same-term in-flight dedupe for fetchRelatedSearchesForSearchPage */
    lastFulfilledSearchTerm: string | null;
    pendingSearchTerm: string | null;
    suggestions: RelatedSearchItem[];
};

export const defaultRelatedSearchesSlice: RelatedSearchesSlice = {
    lastFulfilledSearchTerm: null,
    pendingSearchTerm: null,
    suggestions: [],
};

const initialState = defaultRelatedSearchesSlice;

const relatedSearchesSlice = createSlice({
    extraReducers: (builder) => {
        builder
            .addCase(fetchRelatedSearchesForSearchPage.pending, (state, action) => {
                state.pendingSearchTerm = action.meta.arg;
            })
            .addCase(fetchRelatedSearchesForSearchPage.fulfilled, (state, action) => {
                state.pendingSearchTerm = null;
                state.lastFulfilledSearchTerm = action.meta.arg;
                state.suggestions = action.payload;
            })
            .addCase(fetchRelatedSearchesForSearchPage.rejected, (state, action) => {
                if (action.meta.condition) {
                    return;
                }
                state.pendingSearchTerm = null;
                console.error('fetchRelatedSearchesForSearchPage failed', action.error);
                state.suggestions = [];
            })
            .addCase(submitSearch.fulfilled, (state) => {
                state.lastFulfilledSearchTerm = null;
                state.pendingSearchTerm = null;
                state.suggestions = [];
            });
    },
    initialState,
    name: 'relatedSearches',
    reducers: {
        setRelatedSearchSuggestions: (state, action: { payload: RelatedSearchItem[] }) => {
            state.lastFulfilledSearchTerm = null;
            state.pendingSearchTerm = null;
            state.suggestions = action.payload;
        },
    },
});

export const { setRelatedSearchSuggestions } = relatedSearchesSlice.actions;
export const relatedSearchesReducer = relatedSearchesSlice.reducer;
